<template>
	<Modal @close="$emit('close')" class="delete-lot" ref="deleteModal" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<h3>Delete lot {{lot.num}} </h3>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<p>The selected lot will be deleted from the application permanently.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<button class="button-action button-action-delete" @click="deleteLots">Delete</button>
					<button class="button-action button-action-cancel" @click="$refs.deleteModal.close()">Cancel</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'

export default {
  components: {
		Modal
	},
	props: [
		'lot'
	],
	methods: {
		deleteLots() {
			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`lots/delete`, this.lot)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Lot ${this.lot.num} Deleted`,
					timeout: 3000
				})
				this.$emit('close')
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Lot/Delete.vue